module.exports = __webpack_public_path__ + "img/normal.e0958082.svg";